import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { SubSink } from "subsink";
import { AuthService } from "../../../../../../../auth/auth.service";
import { UserToken } from "../../../../../../../auth/user-token.model";
import { MessagingService } from "../../../../../../../core/messaging/messaging.service";
import { SeverityType } from "../../../../../../../core/messaging/severity-type.enum";
import { ParameterService } from "../../../../../../../core/navigation/parameter.service";
import { UserService } from "../../../../../../../core/user/user.service";
import { Autocomplete } from "../../../../../../../dynamic-forms/inputs/autocomplete/autocomplete.model";
import { CheckboxGroup } from "../../../../../../../dynamic-forms/inputs/checkbox-group/checkbox-group.model";
import { Textbox } from "../../../../../../../dynamic-forms/inputs/textbox/textbox.model";
import { GapGridComponent } from "../../../../../../../shared/gap-grid/gap-grid.component";
import { BulkAction } from "../../../../../../../shared/grid/bulk-actions/bulk-action.model";
import { GridColumnDefinition } from "../../../../../../../shared/grid/models/grid-column-definition.model";
import { GridFilter } from "../../../../../../../shared/grid/models/grid-filter.model";
import { TagType } from "../../../../../../../shared/tags/model/tag-type.enum";
import { ArrayHelper } from "../../../../../../../utilities/contracts/array-helper";
import { NumberHelper } from "../../../../../../../utilities/contracts/number-helper";
import { ChaseSearchRequest } from "../../../../../../api/chase-search/chase-search-request-model";
import { ChaseItem } from "../../../../../../api/chase-search/chase-search-result-item";
import { ChaseSearchService } from "../../../../../../api/chase-search/chase-search.service";
import { GapService } from "../../../../../../api/gap/gap-service";
import { NumeratorListItem } from "../../../../../../api/numerator/numerator-list-item.model";
import { ProviderPacketItem } from "../../../../../internal-pends/internal-pends-detail/internal-pends-detail-info/provider-packet-item.model";
import { ChaseMoveModel } from "../../../../../project/chase-query/chase-move.model";
import { ChaseQueryService } from "../../../../../project/chase-query/chase-query.service";
import { AddressSearchResult } from "../../../../address-search/address-search-result.model";
import { CommitmentDateUpdateModel } from "../../../../commitment-date/commitmentDateUpdate.model";
import { AddressDetailState } from "../../../address-detail-state.model";
import { AddressDetailStateService } from "../../../address-detail-state.service";

@Component({
    selector: "app-address-detail-info-grids-gppursuit",
    templateUrl: "./address-detail-info-grids-gppursuit.component.html",
    styleUrls: ["./address-detail-info-grids-gppursuit.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RetrievalAddressDetailInfoGridsGapPursuitsComponent implements OnInit, OnDestroy {
    @ViewChild(GapGridComponent, { static: true }) gapGridComponent: GapGridComponent;
    addressId: number;
    additionalBulkActions: BulkAction[] = [];
    selection: any[];
    selectedChases: any[];
    private sink = new SubSink();
    isPendModalVisible = false;
    moveChaseText = "Request Move";
    private user: UserToken;
    isAddressModalVisible = false;
    isOutreachModalVisible = false;
    isChaseMoveVisible = false;
    selectedAddress: AddressSearchResult;
    addressSearchCallingSource = "Move Chase";
    chaseMoveModel: ChaseMoveModel;
    addressDetailState: AddressDetailState;
    confirmMoveStatusMessage: string;
    isViewPostMoveVisible = false;
    isCommitmentDateModalVisible = false;
    commitDateUpdateModel: CommitmentDateUpdateModel;
    commitmentDate: Date;
    isGapChasePrintProviderPacketModalVisible = false;
    isGapPursuitPrintProviderPacketModalVisible = false;
    providerPacketItem: ProviderPacketItem;
    nonActionableChasesChecked = false;
    additionalFilters: GridFilter[] = [];
    additionalColumns: GridColumnDefinition[] = [];
    assignedTo: number;
    private documentRetrievalLead = 4;
    private previousMasterDocumentSourceId = 0;
    chaseGridDataAll: ChaseItem[] = [];
    chaseGridData: ChaseItem[] = [];
    gridSearchRequest: ChaseSearchRequest;
    startRecord = 1;
    endRecord = 2147483647; // All records
    @Input() clinical = false;
    isManageTagModalVisible = false;
    totalEntityCount: number;
    entityName: string;
    tagType = TagType.CHASE;
    gapType = "Gap";
    gapTypeFilters: string[];
    gapChaseRows: any[];
    gapPursuitsRows: any[];
    gapOutreachCount = 0;
    isGapChaseOutreachModalVisible = false;
    isGapPursuitOutreachModalVisible = false;
    isAdditionalOutreachPromptVisible = false;

    constructor(
        private readonly addressDetailStateService: AddressDetailStateService,
        private userService: UserService,
        private gapService: GapService,
        private chaseService: ChaseSearchService,
        private messagingService: MessagingService,
        private chaseQryService: ChaseQueryService,
        private changeDetector: ChangeDetectorRef,
        private router: Router,
        private readonly authService: AuthService,
        private parameterService: ParameterService
    ) { }

    ngOnInit() {
        this.addressId = this.parameterService.getNumberNormal("addressId", null);
        this.user = this.userService.getUserToken();
        this.assignedTo = (this.user.functionalRoleIds.indexOf(this.documentRetrievalLead) > -1) ? null : this.user.userId;
        this.moveChaseText = this.isUserMangerAdminLead ? "Move Chase" : "Request Move";

        this.sink.add(
            this.addressDetailStateService.state.subscribe(state => {
                this.addressDetailState = state;

                if (ArrayHelper.isAvailable(this.addressDetailState.chaseGridData)) {
                    this.loadChaseGrid(this.addressDetailState.chaseGridData);
                } else if (this.addressDetailState.hasMasterDocumentSourceId
                    && this.previousMasterDocumentSourceId !== this.addressDetailState.masterDocumentSourceId
                    && !ArrayHelper.isAvailable(this.addressDetailState.chaseGridData)) {
                    this.updateChaseGrid();

                    this.previousMasterDocumentSourceId = this.addressDetailState.masterDocumentSourceId;
                }
            })
        );

        this.additionalBulkActions = [
            new BulkAction({
                name: "Outreach",
                action: this.openGapOutReachModal,
            }),
            new BulkAction({
                name: "Pend Chase(s)",
                action: this.openPendModal,
            }),
            new BulkAction({
                name: this.moveChaseText.concat("(s)"),
                action: this.moveChase,
            }),
            new BulkAction({
                name: "Commitment Date",
                action: this.openCommitmentDateModal,
            }),
            // new BulkAction({
            //  name: "Manage Tags",
            //  action: this.openManageTagModal, /*TODO: This will be a part of next release*/
            //  disabled: this.hasTagManagement,
            // }),
            new BulkAction({
                name: "Print Request(s)",
                action: this.openPrintProvider,
                hasIcon: true,
                iconName: "print",
            }),
        ];

        this.additionalFilters = [
            new GridFilter({
                input: new Autocomplete({ placeholder: "Select..." }),
                key: "ClientId",
                name: "Client",
                show: false,
            }),
            new GridFilter({
                input: new Textbox(),
                key: "AddressId",
                name: "AID",
                value: this.addressId.toString(),
                show: false,
            }),
            new GridFilter({
                input: new Autocomplete({ placeholder: "Select User..." }),
                key: "AssignedToUserId",
                name: "Assigned To",
                value: this.assignedTo != null ? this.assignedTo.toString() : null,
            }),
            new GridFilter({
                input: new CheckboxGroup(),
                key: "ComplianceCodes",
                name: "Chase Compliance",
                show: false,
            }),
        ];

        this.additionalColumns = [
            new GridColumnDefinition({ field: "chaseSourceAliasId", header: "Chase Key", show: false }),
            new GridColumnDefinition({ field: "numeratorName", header: "Gap Attribute", show: false }),
            new GridColumnDefinition({ field: "gapStatus", header: "Gap Status", show: false }),
            new GridColumnDefinition({ field: "clientName", header: "Client", show: false }),
            new GridColumnDefinition({ field: "masterDocumentSourceId", header: "AID", show: false }),
            new GridColumnDefinition({ field: "product", header: "Product", show: false }),
            new GridColumnDefinition({ field: "chaseCreateDate", header: "Created", show: false }),
            new GridColumnDefinition({ field: "assignedTo", header: "Assigned To", show: false }),
            new GridColumnDefinition({ field: "chaseDocumentPageCount", header: "Pages", show: false }),
            new GridColumnDefinition({ field: "pendCode", header: "Pend Code", show: false }),
            new GridColumnDefinition({ field: "pendStatus", header: "Pend Status", show: false }),
            new GridColumnDefinition({ field: "chaseComplianceCode", header: "Chase Compliance", show: false }),
        ];
    }

    ngOnDestroy() {
        this.sink.unsubscribe();
    }

    loadChaseGrid(chaseGridData: ChaseItem[]) {
    this.chaseGridDataAll = chaseGridData;
    this.chaseGridData = this.getChaseGridData();
    const chases = this.chaseGridDataEnabled.map(x => x.chaseID);
    this.chaseService.getChaseList(chases);
    }

    updateChaseGrid() {
        this.gridSearchRequest = new ChaseSearchRequest(
            null, null, null, null, this.addressId, this.assignedTo, null, null, null, null, null,
            null, this.startRecord, this.endRecord);

        this.chaseService
            .chaseSearch(this.gridSearchRequest)
            .subscribe(chaseGridData => {
                this.addressDetailStateService.setData({ chaseGridData });
                this.addressDetailStateService.setData({ openChaseCount: this.chaseGridDataEnabled.length });
                this.loadChaseGrid(chaseGridData);
            });
    }

    getChaseGridData(): any[] {
        this.chaseGridDataAll.forEach(x => {
            // Disable chases not in "Chart collection", "Waiting for chart" workflow status or which are moved or request made or if its Gap(determined by non-empty numeratorlist)
            // Make them non - actionable.
            if ((x.numeratorList !== "")
                || (x.workflowStatusId !== 2 && x.workflowStatusId !== 3)
                || (x.pendCode === "PC900" && (x.pendStatusId === 1 || x.pendStatusId === 2 || x.pendStatusId === 4))) {
                x.disabled = true;
            }
        });

        return this.nonActionableChasesChecked ? this.chaseGridDataAll : this.chaseGridDataEnabled;
    }

    get chaseGridDataEnabled(): any[] {
        return this.chaseGridDataAll.filter(c => !c.disabled);
    }

    openGapOutReachModal = (rowData: any): void => {
        this.setSelectedChases(rowData);
        if (ArrayHelper.isAvailable(this.selectedChases)) {
            this.gapChaseRows = rowData.filter(g => !this.hasParent(g));
            this.gapPursuitsRows = rowData.filter(g => this.hasParent(g));
            this.initiateConsolidatedGapOutreach(this.gapTypeFilters[this.gapOutreachCount]);
        } else {
          this.messagingService.showToast("No Chases to perform Outreach.", SeverityType.WARN);
        }
    }

    private initiateConsolidatedGapOutreach(gapType: string): void {
        let gapDataForOutreach = [];
        this.gapType = gapType;
        this.gapOutreachCount = this.gapOutreachCount + 1;

        switch (gapType) {
            case "Gap Loaded":
            gapDataForOutreach = this.gapChaseRows;

            if (ArrayHelper.isAvailable(gapDataForOutreach)) {
              this.setSelectedChases(gapDataForOutreach);
              this.isGapChaseOutreachModalVisible = true;
            } else {
              this.gapChasePursuitOutreachModalHide();
            }

            break;

            case "Gap Pursuit":
            gapDataForOutreach = this.gapPursuitsRows;

            if (ArrayHelper.isAvailable(gapDataForOutreach)) {
              this.setSelectedChases(gapDataForOutreach);
              this.isGapPursuitOutreachModalVisible = true;
            } else {
              this.gapChasePursuitOutreachModalHide();
            }

            break;

            default:
                break;
        }

    }

    gapChasePursuitOutreachModalHide(): void {
        if (this.gapTypeFilters.length > 1 && this.gapOutreachCount < this.gapTypeFilters.length) {
            this.initiateConsolidatedGapOutreach(this.gapTypeFilters[this.gapOutreachCount]);
        } else {
            this.checkForAdditionalOutreach();
        }
    }

    checkForAdditionalOutreach(): void {
        this.isAdditionalOutreachPromptVisible = this.additionalChaseOutreachCount > 0;
        this.resetGapData();
    }

    resetGapData(): void {
        this.unSelectGridSelection();
        this.gapGridComponent.refreshGrid.emit();
        this.gapType = "Gap";
        this.gapChaseRows = [];
        this.gapPursuitsRows = [];
        this.gapOutreachCount = 0;
    }

    hasParent(gap: any): boolean {
        return NumberHelper.isAvailable(gap.parentChaseId) && gap.parentChaseId > 0;
    }

    get selectedChaseIds(): number[] {
        if (!ArrayHelper.isAvailable(this.selectedChases)) {
            return [];
        }

        return this.selectedChases.map(chase => +chase.chaseId);
    }

    get selectedChaseNumeratorList(): NumeratorListItem[] {
        if (!ArrayHelper.isAvailable(this.selectedChases)) {
            return [];
        }

        return this.selectedChases.map(chase =>
            new NumeratorListItem({
                chaseId: Number(chase.chaseId),
                numeratorId: chase.numeratorId,
                numeratorCode: chase.numeratorCode,
                numeratorName: chase.numeratorName,
            }));
    }

    get isUserMangerAdminLead(): boolean {
        return (this.user.isManagerRole || this.user.isAdminRole || this.user.isLeadRole);
    }

    private setSelectedChases(rowData: any): void {
        this.selectedChases = ArrayHelper.isAvailable(rowData) ? rowData : [rowData];
    }

    openPendModal = (rowData: any): void => {
        this.setSelectedChases(rowData);
        if (ArrayHelper.isAvailable(this.selectedChases)) {
            this.isPendModalVisible = true;
        } else {
            this.messagingService.showToast("Chase(s) not in right status to be actioned upon.", SeverityType.WARN);
        }
    }

    moveChase = (rowData: any): void => {
        this.setSelectedChases(rowData);

        if (ArrayHelper.isAvailable(this.selectedChases)) {
            const checkValue = this.selectedChases.filter(c => c.pendCode);

            if (checkValue.length > 0 && checkValue.length < this.selectedChases.length) {
                this.messagingService.showToast("Please select similar Chases for bulk actions - either with Pend or without Pend", SeverityType.ERROR);
                return;
            } else {
                this.isAddressModalVisible = true;
            }
        } else {
            this.messagingService.showToast("Chase(s) not in right status to be actioned upon.", SeverityType.WARN);
            return;
        }
    }

    onAddressSelectionForChaseMove($event: AddressSearchResult): void {
        this.isChaseMoveVisible = true;
        this.selectedAddress = $event;
    }

    intiateChaseMove(): void {
        this.chaseMoveModel = new ChaseMoveModel({
            toAddressId: this.selectedAddress.masterDocumentSourceId.toString(),
            fromAddressId: this.addressId.toString(),
            chaseIds: this.selectedChaseIds.join(),
            pageType: this.addressDetailState.documentSourceTypeName,
            assignedUser: "",
            status: this.isUserMangerAdminLead ? null : "Pending Approval",
            notes: this.selectedAddress.notes,
            isChaseAssign: this.selectedAddress.isChaseAssign,
        });

        this.chaseQryService.chaseMove(this.chaseMoveModel).subscribe(
            () => {
                this.confirmMoveStatusMessage = this.isUserMangerAdminLead ?
                    `${this.selectedChaseIds.length} chase(s) successfully moved to AID ${this.selectedAddress.masterDocumentSourceId}`
                    : `Move Request for ${this.selectedChaseIds.length} chase(s) to AID ${this.selectedAddress.masterDocumentSourceId} successfully submitted`;

                this.unSelectGridSelection();
                this.gapGridComponent.refreshGrid.emit();

                this.isViewPostMoveVisible = true;
                this.changeDetector.markForCheck();
            },
            err => {
                this.isUserMangerAdminLead
                    ? this.messagingService.showToast(`Error while moving chase to Address ${this.selectedAddress.masterDocumentSourceId}, please try again.`, SeverityType.ERROR)
                    : this.messagingService.showToast(`Error while making chase move request to Address ${this.selectedAddress.masterDocumentSourceId}, please try again.`, SeverityType.ERROR);

                this.unSelectGridSelection();
            }
        );

        this.isChaseMoveVisible = false;
        this.isAddressModalVisible = false;
        this.changeDetector.markForCheck();
    }

    gotoAddressDetail(): void {
        this.isViewPostMoveVisible = false;
        if (this.selectedAddress) {
            this.router.navigateByUrl(`retrieval/addressdetail/${this.selectedAddress.masterDocumentSourceId}`);
        }
    }

    openCommitmentDateModal = (rowData: any): void => {
        this.setSelectedChases(rowData);

        if (ArrayHelper.isAvailable(this.selectedChaseIds)) {
            this.isCommitmentDateModalVisible = true;
        }

        this.commitDateUpdateModel = new CommitmentDateUpdateModel({
            chaseIds: this.selectedChaseIds,
            functionalRoleId: 5, // Document Retrieval
            retrievalLocationId: this.addressId,
        });

        this.commitmentDate = rowData ? rowData.chartCommitmentDate : "";
    }

    unSelectGridSelection(): void {
        this.selectedChases = [];
        this.selection = [];
    }

    openPrintProvider = (rowData: any): void => {
        this.setSelectedChases(rowData);

        if (ArrayHelper.isAvailable(this.selectedChases)) {
            this.gapChaseRows = rowData.filter(g => !this.hasParent(g));
            this.gapPursuitsRows = rowData.filter(g => this.hasParent(g));
            this.initiateConsolidatedPrintGapProviderPacket(this.gapTypeFilters[this.gapOutreachCount]);
        } else {
          this.messagingService.showToast("Chase(s) not in right status to be actioned upon.", SeverityType.WARN);
        }
    }

    private initiateConsolidatedPrintGapProviderPacket(gapType: string): void {
        let gapDataForProviderPacket = [];
        this.gapType = gapType;
        this.gapOutreachCount = this.gapOutreachCount + 1;

        switch (gapType) {
            case "Gap Loaded":
                gapDataForProviderPacket = this.gapChaseRows;

                if (ArrayHelper.isAvailable(gapDataForProviderPacket)) {
                  this.setSelectedChases(gapDataForProviderPacket);

                  if (ArrayHelper.isAvailable(this.selectedChaseIds)) {
                    this.providerPacketItem = new ProviderPacketItem({
                      chaseIds: this.selectedChaseIds,
                      toName: this.addressDetailState.contact.contactName,
                      toPhone: this.addressDetailState.contact.contactPhone,
                      toFax: this.addressDetailState.contact.contactFax,
                      fromName: `${this.user.firstName} ${this.user.lastName}`,
                      fromPhone: this.user.phoneNumber,
                      providerName: "",
                      serviceOrgName: this.user.organizationName,
                      chaseNumeratorList: this.selectedChaseNumeratorList,
                    });

                    this.isGapChasePrintProviderPacketModalVisible = true;
                  }
                } else {
                  this.gapPrintProviderModalHide();
                }

                break;

            case "Gap Pursuit":
                gapDataForProviderPacket = this.gapPursuitsRows;

                if (ArrayHelper.isAvailable(gapDataForProviderPacket)) {
                  this.setSelectedChases(gapDataForProviderPacket);

                  if (ArrayHelper.isAvailable(this.selectedChaseIds)) {
                    this.providerPacketItem = new ProviderPacketItem({
                      chaseIds: this.selectedChaseIds,
                      toName: this.addressDetailState.contact.contactName,
                      toPhone: this.addressDetailState.contact.contactPhone,
                      toFax: this.addressDetailState.contact.contactFax,
                      fromName: `${this.user.firstName} ${this.user.lastName}`,
                      fromPhone: this.user.phoneNumber,
                      providerName: "",
                      serviceOrgName: this.user.organizationName,
                      chaseNumeratorList: this.selectedChaseNumeratorList,
                    });

                    this.isGapPursuitPrintProviderPacketModalVisible = true;
                  }
                } else {
                  this.gapPrintProviderModalHide();
                }

                break;

            default:
                break;
        }

    }

    gapPrintProviderModalHide(): void {
        if (this.gapTypeFilters.length > 1 && this.gapOutreachCount < this.gapTypeFilters.length) {
            this.initiateConsolidatedPrintGapProviderPacket(this.gapTypeFilters[this.gapOutreachCount]);
        } else {
            this.resetGapData();
        }
    }

    get openChases(): ChaseItem[] {
        if (!ArrayHelper.isAvailable(this.addressDetailState.chaseGridData)) {
            return [];
        }

        return this.addressDetailState.chaseGridData.filter(c => !c.disabled);
    }

    get additionalChaseOutreachCount(): number {
        return this.openChases.length;
    }

    disabledRowsFilter = (rowData: any): boolean => {
        return this.gapService.disabledRowsFilterForGapOutReach(rowData);
    }

    get hideDisabledRows(): boolean {
        return !this.nonActionableChasesChecked;
    }

    openManageTagModal = (rowData: any): void => {
        this.setSelectedChases(rowData);
        if (ArrayHelper.isAvailable(this.selectedChases)) {
            this.totalEntityCount = this.selectedChases.length;
            this.entityName = "CHASE";
            this.isManageTagModalVisible = true;
        } else {
            this.messagingService.showToast("Chase(s) not in right status to be actioned upon.", SeverityType.WARN);
        }
    }

    navigateToAdditionalOutreachTab(): void {
        this.router.navigateByUrl(`retrieval/addressdetail/${this.addressDetailState.masterDocumentSourceId}`);
    }

}
